import { Button } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type AllowanceForm from 'modules/timeoff/lib/AllowanceForm'
import type Allowance from 'modules/timeoff/store/models/Allowance'

interface Props {
  allowance: Allowance
  allowanceForm: AllowanceForm
  closeModal: () => void
  onConfirm: () => void
  submitting: boolean
}

const SaveModal = ({ allowance, allowanceForm, closeModal, onConfirm, submitting }: Props) => {
  const title = allowance.isNew
    ? i18n.t('time_off.allowances.modal.create.title')
    : i18n.t('time_off.allowances.modal.update.title')

  const description = () => {
    const name = allowanceForm.get('name').value

    return allowance.isNew
      ? i18n.t('time_off.allowances.modal.create.description', { name })
      : i18n.t('time_off.allowances.modal.update.description', { name })
  }

  const saveButton = allowance.isNew
    ? i18n.t('time_off.allowances.page.button.create')
    : i18n.t('time_off.allowances.page.button.save')

  return (
    <Modal
      illustration="document-approved"
      title={title}
      description={!submitting && description()}
      onClose={closeModal}
      footer={
        <>
          <Button onClick={closeModal} type="secondary">
            {i18n.t('time_off.allowances.page.button.back')}
          </Button>
          <Button disabled={submitting} onClick={onConfirm}>
            {saveButton}
          </Button>
        </>
      }
    >
      {submitting && <Loading />}
    </Modal>
  )
}

export default SaveModal
